import { Check, Circle, X } from 'lucide-react';

export type StepState = 'done' | 'current' | 'pending' | 'failed';

interface Props {
  state: StepState;
}

const StepIcon = ({ state }: Props) => {
  switch (state) {
    case 'done':
      return (
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-success text-white">
          <Check className="h-4 w-4" />
        </span>
      );
    case 'current':
      return (
        <span className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-primary text-primary">
          <Circle className="h-2.5 w-2.5 fill-current" />
        </span>
      );
    case 'failed':
      return (
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-destructive text-destructive-foreground">
          <X className="h-4 w-4" />
        </span>
      );
    default:
      return (
        <span className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-muted text-muted-foreground">
          <Circle className="h-2.5 w-2.5" />
        </span>
      );
  }
};

export default StepIcon;
